var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "booking-format-address" },
    [
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          attrs: { label: _vm.$t("SeaExport.notifyingCode") }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.notifyShortCode } },
            [
              _c("cargo-input", {
                class: _vm.importDifferenceField.notifyShortCode
                  ? "red-border"
                  : "",
                attrs: {
                  placeholder:
                    (_vm.isSeaHouseChannel ||
                      _vm.isWseChannel ||
                      _vm.isRongeTong) &&
                    _vm.isEditing
                      ? _vm.$t("CargoMsg.Cargo_pleaseEnterTheEnterpriseCode")
                      : "",
                  "auto-uppercase": true,
                  "auto-half-word": true
                },
                model: {
                  value: _vm.manifestInfo.notifyShortCode,
                  callback: function($$v) {
                    _vm.$set(_vm.manifestInfo, "notifyShortCode", $$v)
                  },
                  expression: "manifestInfo.notifyShortCode"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          staticClass: "label-right",
          attrs: { label: "+" }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.notifyEnterpriseCode } },
            [
              _c("cargo-input", {
                class: _vm.importDifferenceField.notifyEnterpriseCode
                  ? "red-border"
                  : "",
                attrs: { "auto-uppercase": true, "auto-half-word": true },
                model: {
                  value: _vm.manifestInfo.notifyEnterpriseCode,
                  callback: function($$v) {
                    _vm.$set(_vm.manifestInfo, "notifyEnterpriseCode", $$v)
                  },
                  expression: "manifestInfo.notifyEnterpriseCode"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          ref: "notifyEnterpriseName",
          class: _vm.labelStyle,
          attrs: {
            label: _vm.$t("SeaExport.notifyingName"),
            prop: "notifyEnterpriseName",
            rules: [
              { validator: _vm.validatorNotifyEnterpriseName, trigger: "blur" }
            ]
          }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.notifyEnterpriseName } },
            [
              !_vm.showCombinedManifest
                ? _c("cargo-input", {
                    class: _vm.importDifferenceField.notifyEnterpriseName
                      ? "red-border"
                      : "",
                    attrs: {
                      placeholder: _vm.addressTip,
                      "auto-uppercase": true,
                      "auto-half-word": true,
                      trim:
                        _vm.isSeaHouseChannel ||
                        _vm.isWseChannel ||
                        _vm.isRongeTong
                    },
                    model: {
                      value: _vm.manifestInfo.notifyEnterpriseName,
                      callback: function($$v) {
                        _vm.$set(_vm.manifestInfo, "notifyEnterpriseName", $$v)
                      },
                      expression: "manifestInfo.notifyEnterpriseName"
                    }
                  })
                : _c("cargo-rich-textarea", {
                    class: _vm.importDifferenceField.notifyEnterpriseName
                      ? "red-border"
                      : "",
                    staticStyle: {
                      height: "70px",
                      "min-height": "70px",
                      width: "180px"
                    },
                    attrs: {
                      no: "notifyEnterpriseName",
                      "text-chars": 0,
                      "warning-count": -1,
                      "wrap-symbol": "n",
                      "auto-half-word": "",
                      "auto-uppercase": "",
                      disabled: !_vm.isEditing,
                      "is-trim":
                        _vm.isSeaHouseChannel ||
                        _vm.isWseChannel ||
                        _vm.isRongeTong
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.notifyingName"),
                          _vm.manifestInfo.notifyEnterpriseName,
                          function(val) {
                            _vm.manifestInfo.notifyEnterpriseName = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.manifestInfo.notifyEnterpriseName,
                      callback: function($$v) {
                        _vm.$set(_vm.manifestInfo, "notifyEnterpriseName", $$v)
                      },
                      expression: "manifestInfo.notifyEnterpriseName"
                    }
                  })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          ref: "notifyAddress",
          class: _vm.labelStyle,
          attrs: {
            label: _vm.$t("SeaExport.notifyingDetailAddress"),
            prop: "notifyAddress",
            rules: [{ validator: _vm.validatorNotifyAddress, trigger: "blur" }]
          }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.notifyAddress } },
            [
              !_vm.showCombinedManifest
                ? _c("cargo-input", {
                    class: _vm.importDifferenceField.notifyAddress
                      ? "red-border"
                      : "",
                    attrs: {
                      placeholder: _vm.addressTip2,
                      "auto-uppercase": true,
                      "auto-half-word": true,
                      trim:
                        _vm.isSeaHouseChannel ||
                        _vm.isWseChannel ||
                        _vm.isRongeTong
                    },
                    model: {
                      value: _vm.manifestInfo.notifyAddress,
                      callback: function($$v) {
                        _vm.$set(_vm.manifestInfo, "notifyAddress", $$v)
                      },
                      expression: "manifestInfo.notifyAddress"
                    }
                  })
                : _c("cargo-rich-textarea", {
                    ref: "cargoTextarea1",
                    class: _vm.importDifferenceField.notifyAddress
                      ? "red-border"
                      : "",
                    staticStyle: { height: "110px", width: "180px" },
                    attrs: {
                      no: "notifyAddress",
                      "text-chars": 0,
                      "warning-count": -1,
                      "wrap-symbol": "n",
                      "auto-half-word": "",
                      "auto-uppercase": "",
                      disabled: !_vm.isEditing,
                      "is-trim": true
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.notifyingDetailAddress"),
                          _vm.manifestInfo.notifyAddress,
                          function(val) {
                            _vm.manifestInfo.notifyAddress = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.manifestInfo.notifyAddress,
                      callback: function($$v) {
                        _vm.$set(_vm.manifestInfo, "notifyAddress", $$v)
                      },
                      expression: "manifestInfo.notifyAddress"
                    }
                  })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "auto-width",
          class:
            _vm.manifestInfo.notifyContactsType === 0 ? _vm.labelStyle : "mag",
          staticStyle: { display: "inline-block" },
          attrs: { "label-width": "0" }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c(
                "el-select",
                {
                  class: _vm.importDifferenceField.notifyContactsType
                    ? "require-select red-border"
                    : "require-select",
                  staticStyle: { width: "146px" },
                  on: { change: _vm.changeContactsType },
                  model: {
                    value: _vm.manifestInfo.notifyContactsType,
                    callback: function($$v) {
                      _vm.$set(_vm.manifestInfo, "notifyContactsType", $$v)
                    },
                    expression: "manifestInfo.notifyContactsType"
                  }
                },
                [
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.notifyingPhone"),
                      value: 0
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.notifyingEmail"),
                      value: 1
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("SeaExport.notifyingRelexNumber"),
                      value: 2
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-form-item",
        {
          ref: "notifyPhone",
          staticClass: "auto-width",
          class:
            _vm.manifestInfo.notifyContactsType === 0 ? _vm.labelStyle : "mag",
          staticStyle: { display: "inline-block" },
          attrs: {
            "label-width": "0",
            prop: "notifyContacts",
            rules: [{ validator: _vm.validatorNotifyPhone, trigger: "blur" }]
          }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.notifyContacts } },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content:
                      _vm.manifestInfo.notifyContactsType === 0
                        ? _vm.$t("CargoMsg.Cargo_pleaseEnterAPhoneNumber")
                        : "",
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("cargo-input", {
                    class: _vm.importDifferenceField.notifyContacts
                      ? "red-border"
                      : "",
                    staticStyle: { width: "174px", "margin-left": "4px" },
                    attrs: {
                      "auto-uppercase": true,
                      "auto-half-word": true,
                      placeholder:
                        _vm.manifestInfo.notifyContactsType === 0 &&
                        (_vm.isSeaHouseChannel ||
                          _vm.isWseChannel ||
                          _vm.isRongeTong) &&
                        _vm.isEditing
                          ? _vm.$t("CargoMsg.Cargo_pleaseEnterAPhoneNumber")
                          : ""
                    },
                    model: {
                      value: _vm.manifestInfo.notifyContacts,
                      callback: function($$v) {
                        _vm.$set(_vm.manifestInfo, "notifyContacts", $$v)
                      },
                      expression: "manifestInfo.notifyContacts"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          attrs: { label: _vm.$t("SeaExport.cityName") }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.notifyCityName } },
            [
              _c("cargo-input", {
                class: _vm.importDifferenceField.notifyCityName
                  ? "red-border"
                  : "",
                attrs: { "auto-uppercase": true, "auto-half-word": true },
                model: {
                  value: _vm.manifestInfo.notifyCityName,
                  callback: function($$v) {
                    _vm.$set(_vm.manifestInfo, "notifyCityName", $$v)
                  },
                  expression: "manifestInfo.notifyCityName"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          attrs: { label: _vm.$t("SeaExport.provinceCode") }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.notifyProvinceCode } },
            [
              _c("cargo-input", {
                class: _vm.importDifferenceField.notifyProvinceCode
                  ? "red-border"
                  : "",
                attrs: { "auto-uppercase": true, "auto-half-word": true },
                model: {
                  value: _vm.manifestInfo.notifyProvinceCode,
                  callback: function($$v) {
                    _vm.$set(_vm.manifestInfo, "notifyProvinceCode", $$v)
                  },
                  expression: "manifestInfo.notifyProvinceCode"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          attrs: { label: _vm.$t("SeaExport.provinceName") }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.notifyProvinceName } },
            [
              _c("cargo-input", {
                class: _vm.importDifferenceField.notifyProvinceName
                  ? "red-border"
                  : "",
                attrs: { "auto-uppercase": true, "auto-half-word": true },
                model: {
                  value: _vm.manifestInfo.notifyProvinceName,
                  callback: function($$v) {
                    _vm.$set(_vm.manifestInfo, "notifyProvinceName", $$v)
                  },
                  expression: "manifestInfo.notifyProvinceName"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          attrs: { label: _vm.$t("SeaExport.ZipCode") }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.notifyZipCode } },
            [
              _c("cargo-input", {
                class: _vm.importDifferenceField.notifyZipCode
                  ? "red-border"
                  : "",
                attrs: { "auto-uppercase": true, "auto-half-word": true },
                model: {
                  value: _vm.manifestInfo.notifyZipCode,
                  callback: function($$v) {
                    _vm.$set(_vm.manifestInfo, "notifyZipCode", $$v)
                  },
                  expression: "manifestInfo.notifyZipCode"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          ref: "notifyCountryCode",
          class: _vm.labelStyle,
          attrs: {
            label: _vm.$t("CargoMsg.Cargo_CountryRegionCode"),
            prop: "notifyCountryCode",
            rules: [
              { validator: _vm.validatorNotifyCountryCode, trigger: "change" }
            ]
          }
        },
        [
          _c(
            "el-tooltip",
            {
              attrs: {
                content: _vm.$t("CargoMsg.Cargo_pleaseSelectACountryCode"),
                placement: "bottom",
                effect: "light"
              }
            },
            [
              _c(
                "special-character-tip",
                { attrs: { texts: _vm.specialCharCheck.notifyCountryCode } },
                [
                  !_vm.isSeaHouseChannel &&
                  !_vm.isWseChannel &&
                  !_vm.isRongeTong
                    ? _c("cargo-input", {
                        class: _vm.importDifferenceField.notifyCountryCode
                          ? "red-border"
                          : "",
                        attrs: {
                          "auto-uppercase": true,
                          "auto-half-word": true
                        },
                        model: {
                          value: _vm.manifestInfo.notifyCountryCode,
                          callback: function($$v) {
                            _vm.$set(_vm.manifestInfo, "notifyCountryCode", $$v)
                          },
                          expression: "manifestInfo.notifyCountryCode"
                        }
                      })
                    : _c("cargo-advance-select", {
                        class: _vm.importDifferenceField.notifyCountryCode
                          ? "red-border"
                          : "",
                        attrs: {
                          "static-options": _vm.countryList || [],
                          cache: false,
                          "default-value": _vm.manifestInfo.notifyCountryCode,
                          filterable: "",
                          clearable: "",
                          "filter-tag-names": ["name", "code", "chineseName"],
                          "custom-label": function(item) {
                            return "[" + item.code + "]" + item.name
                          },
                          "tag-name": "name",
                          "tag-value": "code",
                          placeholder: _vm.$t(
                            "CargoMsg.Cargo_pleaseSelectACountryCode"
                          )
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.manifestInfo.notifyCountryCode = p.value
                          }
                        }
                      })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.notSeaHouseChannelOrWseChannel,
              expression: "notSeaHouseChannelOrWseChannel"
            }
          ],
          attrs: { label: _vm.$t("SeaExport.aeoEnterpriseCode") }
        },
        [
          _c(
            "special-character-tip",
            { attrs: { texts: _vm.specialCharCheck.notifyAeoEnterpriseCode } },
            [
              _c("cargo-input", {
                class: _vm.importDifferenceField.notifyAeoEnterpriseCode
                  ? "red-border"
                  : "",
                attrs: { "auto-uppercase": true, "auto-half-word": true },
                model: {
                  value: _vm.manifestInfo.notifyAeoEnterpriseCode,
                  callback: function($$v) {
                    _vm.$set(_vm.manifestInfo, "notifyAeoEnterpriseCode", $$v)
                  },
                  expression: "manifestInfo.notifyAeoEnterpriseCode"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "center",
            "align-items": "center"
          }
        },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.notSeaHouseChannelOrWseChannel,
                  expression: "!notSeaHouseChannelOrWseChannel"
                }
              ],
              staticStyle: { "margin-left": "5px", height: "28px" },
              attrs: { type: "primary" },
              on: { click: _vm.copyRecipient }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CopyRecipient")))]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "advanceTextDialog",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            },
            close: _vm.closeAdvanceText
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              no: "advanceTextDialogTextarea",
              disabled: !_vm.isEditing,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              "auto-uppercase": _vm.advanceTextDialog.formatObj.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c("span", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isEditing,
                    expression: "isEditing"
                  }
                ],
                staticClass: "el-button el-button--default el-button--mini",
                attrs: { no: "advanceTextDialogConfirm", type: "button" },
                on: { click: _vm.finishAdvanceText }
              },
              [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
            ),
            _c(
              "button",
              {
                staticClass: "el-button el-button--default el-button--mini",
                attrs: { no: "advanceTextDialogClose", type: "button" },
                on: {
                  click: function($event) {
                    _vm.advanceTextDialog.visible = false
                    _vm.closeAdvanceText()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }